import React, { Fragment, useState } from "react";
import {
  TableCell,
  TableRow,
  Button,
  Collapse,
  Paper,
  Typography,
  TextField,
  CardMedia,
  Container,
  Grid,
} from "@material-ui/core";
import ArrowUp from "../icons/ArrowUp";
import ArrowDown from "../icons/ArrowDown";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { RenderArea } from "../utils";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

interface StaffTableRowProps {
  row: any;
  columns: any;
  index: number;
  tableLists: any[];
  isStaffCodeEdit: any;
  setIsStaffCodeEdit: (edit: any) => void;
  isJoinDateEdit: any;
  setIsJoinDateEdit: (edit: any) => void;
  setStaffCode: (code: string) => void;
  staffCode: string;
  staffJoinDate: Date;
  setStaffJoinDate: (date: Date) => void;
  HandleUpdateStaffCode: (id: string) => void;
  HandleUpdateStaffJoinDate: (id: string) => void;
  FetchDocLists: (row: any) => void;
  setGlobalData: (data: any) => void;
  globalData: any;
  editImage: string;
  handleToggleExpand: (index: number) => void;
  useStyles: any;
}

const StaffTableRow: React.FC<StaffTableRowProps> = ({
  row,
  columns,
  index,
  tableLists,
  isStaffCodeEdit,
  setIsStaffCodeEdit,
  isJoinDateEdit,
  setIsJoinDateEdit,
  setStaffCode,
  staffCode,
  staffJoinDate,
  setStaffJoinDate,
  HandleUpdateStaffCode,
  HandleUpdateStaffJoinDate,
  FetchDocLists,
  setGlobalData,
  globalData,
  editImage,
  handleToggleExpand,
  useStyles,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const personalInfo = require("../icons/personal_info.png");
  const personalInfoWhite = require("../icons/personal_info_white.png");
  const otherForm = require("../icons/other_form.png");
  const otherFormWhite = require("../icons/other_form_white.png");

  const [imageSrcPersonal, setImageSrcPersonal] = useState(personalInfo);
  const [imageSrcOther, setImageSrcOther] = useState(otherForm);

  // Common button styles for consistency
  const cancelButtonStyle = {
    backgroundColor: "#fff",
    color: "#454C96",
    width: "90%",
    border: "2px solid #454C96",
    borderRadius: "12px",
    padding: "10px 0",
    height: "40px"
  };

  const confirmButtonStyle = {
    width: "90%", 
    backgroundColor: "#454C96",
    borderRadius: "12px",
    padding: "10px 0", 
    height: "40px"
  };

  const RenderValue = (column: any, value: any, row: any) => {
    const _date =
      moment(value).format("YYYY-MM-DD") === "Invalid date"
        ? "-"
        : moment(value).format("YYYY-MM-DD");
    const targetStaffCode = tableLists?.find(
      (o) => o.id === row?.id
    )?.staffCode;

    const joinDate = tableLists?.find((o) => o.id === row?.id)?.joinDate;

    if (column.id === "staff_signature_date") return _date;
    if (column.id === "staff_code") return targetStaffCode || value;
    if (column.id === "joinDate")
      return joinDate
        ? moment(joinDate).format("YYYY-MM-DD")
        : "";
    if (column.id === "area") return RenderArea(value);
    return value;
  };

  const unexpandedRow = () => {
    const columnsComponent = () => {
      return (
        <>
          {columns.map((column, idx) => {
            const value = row[column.id];
            if (column.id === "action") {
              return (
                <TableCell key={column.id} style={{ border: "none" }}>
                  <Button
                    onClick={() => handleToggleExpand(index)}
                    className={classes.arrow}
                  >
                    {tableLists[index]?.expanded ? (
                      <ArrowUp width={14} height={8} fillColor="#454C96" />
                    ) : (
                      <ArrowDown width={14} height={8} fillColor="#84909F" />
                    )}
                  </Button>
                </TableCell>
              );
            } else {
              return (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ border: "none" }}
                >
                  {RenderValue(column, value, row)}
                </TableCell>
              );
            }
          })}
        </>
      );
    };
    return (
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={index}
        className={
          row?.expanded
            ? classes.tableRowPaperTopLeftRight
            : classes.tableRowPaper
        }
      >
        {columnsComponent()}
      </TableRow>
    );
  };

  const expandedRow = () => {
    return (
      <>
        {unexpandedRow()}
        <TableRow>
          <TableCell style={{ padding: "0 0", border: "0px" }} colSpan={7}>
            <Collapse in={row?.expanded} timeout="auto" unmountOnExit>
              <Paper
                className={`${classes.customPaper} ${classes.tableRowPaperLeftRightBottom}`}
              >
                {isStaffCodeEdit?.id === row?.id && !!isStaffCodeEdit?.edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#84909F",
                        fontWeight: "500",
                      }}
                    >
                      員工編號
                    </Typography>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      value={staffCode}
                      onChange={(e) => setStaffCode(e.target.value)}
                      className={classes.input}
                      InputProps={{
                        className: classes.input,
                      }}
                    />
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "center", marginTop: "10px" }}
                      >
                        <Button
                          variant="contained"
                          color={"primary"}
                          style={cancelButtonStyle}
                          onClick={() => {
                            setIsStaffCodeEdit({ edit: false, id: 0 });
                          }}
                        >
                          取消
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "center", marginTop: "10px" }}
                      >
                        <Button
                          variant="contained"
                          color={"primary"}
                          style={confirmButtonStyle}
                          onClick={() => {
                            if (staffCode !== null) {
                              HandleUpdateStaffCode(row?.id);
                            }
                          }}
                        >
                          確認
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <Button
                    startIcon={
                      <CardMedia
                        component="img"
                        image={editImage}
                        alt=""
                        className={classes.media}
                      />
                    }
                    variant="contained"
                    className={classes.editButton}
                    onClick={() => {
                      setIsStaffCodeEdit({ edit: true, id: row?.id });
                    }}
                  >
                    修改員工編號
                  </Button>
                )}
                {isJoinDateEdit?.id === row?.id && !!isJoinDateEdit?.edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#84909F",
                        fontWeight: "500",
                      }}
                    >
                      入職日期
                    </Typography>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        fullWidth
                        inputVariant="outlined"
                        format="yyyy-MM-dd"
                        value={staffJoinDate ? staffJoinDate : null}
                        clearable // Allows clearing the date
                        placeholder="" // Empty placeholder instead of default
                        invalidDateMessage="" // Remove invalid date message
                        invalidLabel=""  // Empty string for invalid date label
                        emptyLabel=""    // Empty string for empty date label
                        onChange={(date) => {
                          if (date) {
                            setStaffJoinDate(date);
                          } else {
                            setStaffJoinDate(null);
                          }
                        }}
                        InputProps={{
                          placeholder: "",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "center", marginTop: "10px" }}
                      >
                        <Button
                          variant="contained"
                          color={"primary"}
                          style={cancelButtonStyle}
                          onClick={() => {
                            setIsJoinDateEdit({ edit: false, id: 0 });
                          }}
                        >
                          取消
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "center", marginTop: "10px" }}
                      >
                        <Button
                          variant="contained"
                          color={"primary"}
                          style={confirmButtonStyle}
                          onClick={() => {
                            if (staffJoinDate !== null) {
                              HandleUpdateStaffJoinDate(row?.id);
                            }
                          }}
                        >
                          確認
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <Button
                    startIcon={
                      <CardMedia
                        component="img"
                        image={editImage}
                        alt=""
                        className={classes.media}
                      />
                    }
                    variant="contained"
                    className={classes.editButton}
                    onClick={() => {
                      setIsJoinDateEdit({ edit: true, id: row?.id });
                    }}
                  >
                    修改入職日期
                  </Button>
                )}
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "0.3rem",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={classes.imageForm}
                    onMouseEnter={() => setImageSrcPersonal(personalInfoWhite)}
                    onMouseLeave={() => setImageSrcPersonal(personalInfo)}
                    onClick={() => {
                      navigate("/StaffInfoFormSigned", {
                        state: {
                          targetInfo: row,
                          isHaveData: true,
                        },
                      });
                      setGlobalData({
                        ...globalData,
                        targetInfo: row,
                        isHaveData: true,
                      });
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={imageSrcPersonal}
                      alt=""
                      className={classes.arrow}
                    />
                    <Typography
                      style={{
                        color:
                          imageSrcPersonal === personalInfoWhite
                            ? "#ffff"
                            : "#454C96",
                        paddingTop: "1rem",
                      }}
                    >
                      個人資料表格
                    </Typography>
                  </div>
                  <div
                    onClick={() => {
                      FetchDocLists(row);
                    }}
                    onMouseEnter={() => setImageSrcOther(otherFormWhite)}
                    onMouseLeave={() => setImageSrcOther(otherForm)}
                    className={classes.imageForm}
                    style={{ marginLeft: "2rem" }}
                  >
                    <CardMedia
                      onClick={() => {}}
                      component="img"
                      image={imageSrcOther}
                      alt=""
                      className={classes.arrow}
                    />
                    <Typography
                      style={{
                        color:
                          imageSrcOther === otherFormWhite
                            ? "#ffff"
                            : "#454C96",
                        paddingTop: "1rem",
                      }}
                    >
                      其他文件
                    </Typography>
                  </div>
                </div>
              </Paper>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };

  return (
    <Fragment key={index}>
      {row?.expanded ? expandedRow() : unexpandedRow()}
      <div style={{ marginTop: "0.5rem" }}></div>
    </Fragment>
  );
};

export default StaffTableRow;
